import React, { useEffect, useState } from "react";
import queryString from 'query-string';

// reactstrap components
import { Card, CardBody, Row, Col } from "reactstrap";


// services
import { showMessage } from "../../services/message.js";
import { api_GET } from "../../services/api_service.js";
import { formateDate } from "../../helpers/formats";

// components
import LogoSistema from "../../components/LogoSistema/LogoSistema";

//Context
import { useAuth } from "../../context/auth";

export default function CertificadoRSS({ history }) {
    const { setLoading, setupSistema } = useAuth();

    const d = new Date();
    var QRCode = require('qrcode.react');

    const [dadoscarteirinha, set_dadoscarteirinha] = useState(null);
    const loadDados = () => {
        let urls = history.location.search;
        let params = queryString.parse(urls);

        setLoading(true);
        api_GET('ProtocoloGerador/ByNumeroProtocolo/' + params.protocolo).then(result => {
            if (["Cancelado", "Pendente", "Inativo"].includes(result.data.status)) {
                if (result.data.status == "Inativo") {
                    showMessage("Aviso", "Cadastro Inativo no Sistema.", 'error', null);
                    return;
                } else {
                    showMessage("Aviso", "Carteirinha não disponível", 'error', null);
                    return;
                }
            }

            let protocolo = result.data;
            let _carteirinha = {
                codCadastro: protocolo.codigoCadastro,
                dataCadastro: protocolo.dataCadastro,
                nome: protocolo.protocoloGerador[0].razaoSocial != null && protocolo.protocoloGerador[0].razaoSocial != "" ? protocolo.protocoloGerador[0].razaoSocial : protocolo.protocoloGerador[0].nome_Fantasia,
                cpfCnpj: protocolo.cpf_Cnpj,
                endereco: protocolo.protocoloGerador[0].logradouro,
                numero: protocolo.protocoloGerador[0].numEndereco,
                complemento: protocolo.protocoloGerador[0].complemento,
                bairro: protocolo.protocoloGerador[0].bairro,
                cep: protocolo.protocoloGerador[0].cep,
                telefone: protocolo.protocoloGerador[0].telefone,
                tipoEstabelecimento: protocolo.protocoloGerador[0].tipoEstabelecimento != null ? protocolo.protocoloGerador[0].tipoEstabelecimento.descricao : "",
                protocolo: params.protocolo
            }
            set_dadoscarteirinha(_carteirinha);
        }
        )
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadDados();
    }, []);

    return (
        <>
            {dadoscarteirinha != null &&
                <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                    <Card style={{ width: "100%", height: "29.7cm" }}>
                        <CardBody>
                            <div style={{ border: "1px solid black", padding: "0.5cm" }}>
                                <Row style={{ borderBottom: "1px solid black", alignItems: "center" }}>
                                    <Col md="3" style={{ justifyContent: "center" }}>
                                        <LogoSistema identificacaoLogo={"logotipo"} width='150' style={{ marginTop: "10px", marginBottom: "10px" }} />
                                    </Col>
                                    <Col md="6" className="text-center">
                                        <h5 style={{ marginTop: "10px", marginBottom: "5px" }}><strong>Agência Reguladora de Serviços Públicos </strong></h5>
                                        <h5 style={{ marginBottom: "10px" }}><strong>do Município de São Paulo</strong></h5>
                                    </Col>
                                    <Col md="3" className="text-right" style={{ justifyContent: "center" }}>
                                        <LogoSistema identificacaoLogo={"logoSecundario"} width='160rem' />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" className="text-center mt-2">
                                        <h3 style={{ marginBottom: "10px" }}><b>Certificado de Cadastramento</b></h3>
                                        <h5><b>Coleta de Resíduos de Serviços de Saúde</b></h5>
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col md="3">
                                        Código do Gerador:
                                    </Col>
                                    <Col md="9">
                                        <strong>{dadoscarteirinha.codCadastro}</strong>
                                    </Col>
                                    <Col md="3">
                                        Nome do Estabelecimento:
                                    </Col>
                                    <Col md="9">
                                        <strong>{dadoscarteirinha.nome}</strong>
                                    </Col>
                                    <Col md="3">
                                        CPF / CNPJ:
                                    </Col>
                                    <Col md="9">
                                        <strong>{dadoscarteirinha.cpfCnpj}</strong>
                                    </Col>
                                    <Col md="3">
                                        Endereço:
                                    </Col>
                                    <Col md="9">
                                        <strong>{dadoscarteirinha.endereco}</strong>
                                    </Col>
                                    <Col md="3">
                                        Número:
                                    </Col>
                                    <Col md="9">
                                        <strong>{dadoscarteirinha.numero}</strong>
                                    </Col>
                                    <Col md="3">
                                        Complemento:
                                    </Col>
                                    <Col md="9">
                                        <strong>{dadoscarteirinha.complemento}</strong>
                                    </Col>
                                    <Col md="3">
                                        Bairro:
                                    </Col>
                                    <Col md="9">
                                        <strong>{dadoscarteirinha.bairro}</strong>
                                    </Col>
                                    <Col md="3">
                                        CEP:
                                    </Col>
                                    <Col md="9">
                                        <strong>{dadoscarteirinha.cep}</strong>
                                    </Col>
                                    <Col md="3">
                                        Telefone:
                                    </Col>
                                    <Col md="9">
                                        <strong>{dadoscarteirinha.telefone}</strong>
                                    </Col>
                                    <Col md="3">
                                        Tipo de Estabelecimento:
                                    </Col>
                                    <Col md="9">
                                        <strong>{dadoscarteirinha.tipoEstabelecimento}</strong>
                                    </Col>
                                    <Col md="3">
                                        Data de Cadastro:
                                    </Col>
                                    <Col md="9">
                                        <strong>{formateDate(dadoscarteirinha.dataCadastro)}</strong>
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col md="12" className="text-justify">
                                        <p>O estabelecimento citado encontra-se cadastrado junto a Agência Reguladora de Serviços Públicos do Município de São Paulo - SP REGULA
                                            para a Coleta de Resíduos de Serviços de Saúde e deverá obedecer todas as exigências legais próprias deste serviço (Decreto Municipal 37066/97).
                                        </p>
                                    </Col>
                                    <Col md="12" className="text-center mt-2">
                                        <strong>São Paulo, {formateDate(d.toDateString())}</strong>
                                    </Col>
                                    <Col md="12" className="text-center mt-4 mb-2">
                                        <QRCode value={setupSistema?.urL_WEB_ROC + "/empty/CertificadoRSS?protocolo=" + dadoscarteirinha.protocolo} />
                                    </Col>
                                </Row>
                                <Row style={{ border: "1px solid black", margin: "15px" }} className="pt-2">
                                    <Col md="12" className="text-justify">
                                        <p style={{ marginBottom: "5px" }}><strong>Exigências Mínimas:</strong></p>
                                        <p style={{ marginBottom: "5px" }}>1. Apresentar para a coleta somente resíduos infectantes;</p>
                                        <p style={{ marginBottom: "5px" }}>2. Adicionar todos os resíduos em sacos plásticos branco-leitosos, padrão ABNT NBR-9190.<br />
                                            Utilizar até 2/3 do volume da embalagem que deve ser fechada e apresentada sem vazamentos;</p>
                                        <p style={{ marginBottom: "5px" }}>3. Acondicionar os materiais perfurocortantes em embalagens rígidas, previamente em saco plástico branco-leitoso;</p>
                                        <p style={{ marginBottom: "5px" }}>4. Os abrigos para os resíduos devem apresentar o padrão ABNT NBR-12809 e ser desinfetados e lavados periodicamente;</p>
                                        <p style={{ marginBottom: "5px" }}>5. Fácil acesso dos veículos coletores ao abrigo de resíduos;</p>
                                        <p style={{ marginBottom: "5px" }}>6. Respeito aos funcionários da coleta.</p>
                                    </Col>
                                </Row>
                                <Row style={{ border: "2px solid black", margin: "15px" }}>
                                    <Col md="12" className="text-center">
                                        <strong>Solicitações, Reclamações ou Sugestões na prestação de serviços, favor acessar o Portal 156.</strong>
                                    </Col>
                                </Row>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            }
        </>
    );
}